<template>
  <div class="section fp-auto-height-responsive" id="safeguard-section">
    <v-container>
      <v-row>
        <v-col cols="12" xl="8" offset-xl="2">
          <v-row>
            <v-col cols="12" sm="6" class="text-center">
              <img ref="img" class="service-visual" src="@/assets/new/image/main/home_safeguard.svg" alt="세이프가드·금융사기방지" />
            </v-col>
            <v-col cols="12" sm="6" class="d-sm-flex align-sm-center justify-start justify-sm-end">
              <div class="section-contents  text-center text-sm-right" ref="title">
                <h6>세이프가드·금융사기방지</h6>
                <h1>나의 금융 거래를<br /><b>더 안전하게!</b></h1>
                <p>고객님의 금융 정보를 365일 24시간 <br class="br" />모니터링 하고, 의심스러운 금융 거래와 <br class="br" />금융 사고로부터 보호합니다.</p>
                <div class="btn" @click.stop="moveService" :data-ga-category="gaEvent.category.home.name" :data-ga-label="gaEvent.category.home.label2" :data-ga-action="gaEvent.actions.buttonClick">더보기<img src="@/assets/new/image/main/arrow_right.svg" alt="세이프가드·금융사기방지 더보기" /></div>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { gsap } from "gsap";
import {GaTracking} from "@/mixins/index.js";
const { mapGetters } = createNamespacedHelpers("ui");

export default {
  mixins: [GaTracking],
  name: "SafeGuard",
  components: {},
  computed: {
    ...mapGetters(["sectionNumber"])
  },
  watch: {
    sectionNumber() {
      const { title, img } = this.$refs;

      if (this.sectionNumber === 3) {
        gsap.to(title, .5, { opacity: 1, y: 0 })
        gsap.to(img, .5, { delay: .3, opacity: 1, y: 0 });
      }
    }
  },
  methods:{
    moveService(e){
      this.gaTracking(e);
      this.$router.push({name: 'SafeGuard'});
    }
  }
};
</script>
